<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first">“Once you have tasted flight, you will forever walk the earth with your eyes turned skyward, for there you have been and there you long to return.”</p>
<p class="blockquote-attribution blockquote-position-last">Leonardo Da Vinci, 1452 – 1519</p>
</div>
<hr class="implicit-break"/>
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose">“If you wish to understand the universe, you must think of energy, frequency, and vibration. Electricity is all around us.”</p>
<p class="blockquote-attribution blockquote-position-last">Nikola Tesla, 1856–1943</p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5362ba34